<template>
    <footer class="app-footer">
        <span>Belichtingstool {{versie}} - <a href="http://www.thomasmore.be">Kenniscentrum Energie (KCE) - Thomas More Kempen</a> &copy; 2019-2020</span>
        <!-- <span class="ml-auto">Powered by <a href="http://coreui.io">CoreUI</a></span> -->
    </footer>
</template>

<script>
export default {
    name: 'footer',
    computed: {
        versie () {
            return process.env.VERSIE;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/nav_components/Footer.vue